import {Navigate, Route, Routes} from "react-router-dom";
import PracticeRoot from "./root/PracticeRoot";
import QuestionPagesIndex from "./QuestionPages";

export default function PracticeIndex({className, ...props}) {

    return (

        <Routes>
            <Route path={"/"} element={<PracticeRoot/>}/>
            <Route path={"/*"} element={<QuestionPagesIndex/>}/>
            <Route path={"/:cat"} element={<PracticeRoot/>}/>
        </Routes>
    )
}
